import { RootPaths } from "@src/appV2/App/paths";

export const COURSE_PLAYER_PATH = "courses/:requirementId";
export const COURSE_PLAYER_FULL_PATH = `${RootPaths.APP_V2_HOME}/courses`;
